import { render } from "./UpdatePinSettingView.vue?vue&type=template&id=70a61e15"
import script from "./UpdatePinSettingView.vue?vue&type=script&lang=js"
export * from "./UpdatePinSettingView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__